import WithAuth from './with-auth-controller'

export default WithAuth
